import React, { Children, useState } from "react";
import Drawer from "@mui/material/Drawer";

// import JS files

// import Others files

const MuiDrawer = ({ children, openDrawer, setOpenDrawer, anchor }) => {
  let windowWidth = window.screen.width;
  return (
    <>
      <Drawer
        anchor={anchor}
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
      >
        {children}
      </Drawer>
    </>
  );
};

export default MuiDrawer;
